import {UntilDestroy} from "@ngneat/until-destroy";
import {Component, Inject, OnInit} from "@angular/core";
import {WORKBENCH_VIEW_CONFIG, WorkbenchViewConfig} from '../../../shared/types';
import {ConsoleSessionId, DeviceId, ProjectId} from "@webmate-web-core/shared/types/ids";
import {BrowserSessionInfo} from "@webmate-web-core/shared/types/browsersession";
import {Subject} from "rxjs";
import {WorkbenchViewComponent} from "../../../shared/components/viewcontainers/workbench-view.component";
import {WorkbenchLayoutManager} from "../../../shared/services/workbench-layout-manager.service";
import {WorkbenchContextService} from '../../../shared/services/workbench-context.service';

@UntilDestroy()
@Component({
    templateUrl: './expedition-timeline.component.html',
    styleUrls: ['./expedition-timeline.component.less'],
})
export class ExpeditionTimelineComponent extends WorkbenchViewComponent implements OnInit {

    projectId: ProjectId;

    activeExpedition?: BrowserSessionInfo;

    deviceId: DeviceId;
    consoleSessionId: ConsoleSessionId;

    wantRefresh: Subject<void> = new Subject<void>();


    constructor(@Inject(WORKBENCH_VIEW_CONFIG) public config: WorkbenchViewConfig<any>,
                layoutManager:  WorkbenchLayoutManager,
                private contextService: WorkbenchContextService) {
        super(layoutManager, config);
    }

    ngOnInit() {
        const workbenchContext = this.contextService.getCurrentWorkbenchContext()!;
        this.projectId = workbenchContext.project;

        this.contextService.subscribeWorkbenchContext$().pipe(
        ).subscribe(_ => {
        });

        this.wantRefresh.next(undefined);
    }
}
